module.exports = __webpack_public_path__ + "img/place4.1fc3b391.jpg";